import * as Sentry from "@sentry/react";

/**
 * Browser implementation of `IFeedback` that opens Sentry's hosted
 * feedback form. Silently no-ops when Sentry's feedback integration
 * isn't initialised (e.g. when SDK init failed at boot).
 */
export const sentryFeedback = {
	async openForm() {
		const feedback = Sentry.getFeedback();
		if (!feedback) return;
		const form = await feedback.createForm();
		form.appendToDom();
		form.open();
	},
};
